import React, { useState, useEffect } from 'react'
import { ReactComponent as LogoutIconOutline } from 'presentation/assets/icons/logout-outline.svg'
import { observer } from 'mobx-react'
import { MenuItem, items } from './items'

import * as S from './styles'
import { useStores } from 'presentation/hooks/use-stores'
import { useHistory } from 'react-router'
import { Profile } from 'common/enum/profile'
import { LocalStorageAdapter } from 'infra/storage-adapter/storage-adapter'

type Props = {
  menuOpen?: boolean
}

const Menu = observer(({ menuOpen }: Props) => {
  const history = useHistory()
  const userContext = useStores().currentAccount
  const user = userContext?.getCurrentAccount()?.user
  const permissions = useStores().permissions
  const [menuItems, setMenuItems] = useState<MenuItem[]>([])

  const logout = () => {
    const localStorage = new LocalStorageAdapter()
    userContext.removeCurrentAccount()
    permissions.clean()
    localStorage.set('crmo-flags')
    history.push('/login')
  }

  const handleClickMenuItem = (item: MenuItem) => {
    if (item.isAddCollaboratorAdmin) {
      return history.push({
        pathname: item.link,
        state: {
          isAddCollaboratorAdmin: true
        }
      })
    }

    history.push(item.link, {
      label: item.label
    })
  }

  useEffect(() => {
    // Filter menu items by user roles (profiles)
    let filteredMenu: MenuItem[] = []
    if (
      user.isMain === Profile.SETOR_DE_MARCACAO ||
      user.isMainRole === Profile.SETOR_DE_MARCACAO
    ) {
      filteredMenu = items.filter((item) =>
        item.profiles.some(
          (profile) =>
            user?.groups?.includes(profile) ||
            profile === user.isMainRole ||
            profile === user.isMain
        )
      )
    } else {
      filteredMenu = items.filter((item) =>
        item.profiles.some(
          (profile) =>
            user?.groups?.includes(profile) ||
            profile === user.isMainRole ||
            profile === user.isMain ||
            profile === user.role
        )
      )
    }
    setMenuItems(filteredMenu)
  }, [])

  return (
    <S.Wrapper open={menuOpen}>
      {menuItems &&
        menuItems.map((item, index) => (
          <S.MenuItem
            onClick={() => handleClickMenuItem(item)}
            key={index}
            active={history.location.pathname === item.link}
            title={item.label}
          >
            {item.icon}
            <S.MenuLink open={menuOpen}>{item.label}</S.MenuLink>
          </S.MenuItem>
        ))}

      <S.MenuItem onClick={logout}>
        <LogoutIconOutline />
        <S.MenuLink open={menuOpen}>Sair</S.MenuLink>
      </S.MenuItem>
    </S.Wrapper>
  )
})

export default Menu
